export function logClientError(context, err) {
  if (process.env.NODE_ENV !== "production") {
    console.error(`[portal:${context}]`, err);
  }
}
